/** 멀티파트 업로드 기준 크기: 50MB */
export const MULTIPART_THRESHOLD = 50 * 1024 * 1024;
